export default __webpack_public_path__ + "static/media/cp_geo_cr.b9e32234.svg";